export const handleErrorActivateMarginBoost = (
  error: any,
  onError: () => void,
): void => {
  const errorMessage =
    error.response?.data?.error ||
    'An error occurred while activating the margin boost.';
  onError();
  console.error(errorMessage, error);
};
